"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanLevel = exports.ChangeType = void 0;
let ChangeType = exports.ChangeType = /*#__PURE__*/function (ChangeType) {
  ChangeType["ACTIVATION"] = "activation";
  ChangeType["UPGRADE"] = "upgrade";
  ChangeType["DOWNGRADE"] = "downgrade";
  return ChangeType;
}({});
/** @deprecated Will be dropped in future */
let PlanLevel = exports.PlanLevel = /*#__PURE__*/function (PlanLevel) {
  PlanLevel["BASIC"] = "basic";
  PlanLevel["CORE"] = "core";
  PlanLevel["ENTERPRISE"] = "enterprise";
  PlanLevel["EXPERT"] = "expert";
  PlanLevel["NONE"] = "";
  PlanLevel["PREMIUM"] = "premium";
  PlanLevel["PROFESSIONAL"] = "professional";
  PlanLevel["STARTER"] = "starter";
  PlanLevel["AGENCY_SMALL"] = "agency_small";
  PlanLevel["AGENCY_MEDIUM"] = "agency_medium";
  PlanLevel["AGENCY_LARGE"] = "agency_large";
  PlanLevel["AGENCY_HUGE"] = "agency_huge";
  return PlanLevel;
}({});